export * from './useExtensionsAppsDockControl';
